export enum FormulaOperationEnum {
	Divide = 'divide',
	Multiply = 'multiply',
	Add = 'add',
	Subtract = 'subtract',
}
